/*********************************************************************
 **************************  APP CONFIG  *****************************
 *********************************************************************/
export const LOCAL_STORAGE_PREFIX = 'bwdeals';
export const APP_NAME = 'Sistema Acuerdos';

export const DEALS_EDIT_PERMISSION = 'deals-edit';
